import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router';

import LongTextQuestionDetail from './LongTextQuestionDetail';
import MultiSelectQuestionDetail from './MultiSelectQuestionDetail';
import NotLoadedQuestionDetail from './NotLoadedQuestionDetail';
import RedirectToAssessment from './RedirectToAssessment';
import { resolveAssessmentCohorts } from 'js/utils/assessment-cohorts';

function getQuestionDetailComponent(question) {
  switch (question?.type) {
    case 'long-text':
      return LongTextQuestionDetail;

    case 'multi-select':
    case 'single-select':
      return MultiSelectQuestionDetail;

    case undefined:
      return NotLoadedQuestionDetail;

    default:
      return RedirectToAssessment;
  }
}

const QuestionDetail = ({ assessments, ...props }) => {
  const {
    params: { assessmentId, questionId: matchQuestionId },
  } = useRouteMatch();
  const questionId = +matchQuestionId;

  const { assessment, question, cohorts, participantCohortMap } =
    useMemo(() => {
      const assessment = assessments.find((a) => a.id === assessmentId);
      const questions =
        assessment?.question_sets.flatMap((qs) => qs.questions) ?? [];

      const question = questions.find((q) => q.id === questionId);
      const resolved = resolveAssessmentCohorts(assessment);

      return {
        assessment,
        question,
        cohorts: resolved.cohorts,
        participantCohortMap: resolved.participantCohortsMap,
      };
    }, [assessments, questionId, assessmentId]);

  const QuestioDetailComponent = getQuestionDetailComponent(question);

  const componentProps = {
    ...props,
    assessment,
    question,
    cohorts,
    participantCohortMap,
  };

  return <QuestioDetailComponent {...componentProps} />;
};

export default QuestionDetail;
